const DOCUMENT = 'TALENT_JOB_INVITES_';

const actions = {
  LOAD: DOCUMENT + 'LOAD',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  PROCESS_ACTION: DOCUMENT + 'PROCESS_ACTION',

  loadData: payload => ({ type: actions.LOAD, payload }),

  loadDataSuccess: payload => ({ type: actions.LOAD_SUCCESS, payload }),

  clearStore: payload => ({ type: actions.CLEAR_STORE, payload }),

  onProcessAction: data => ({ type: actions.PROCESS_ACTION, payload: data }),
};

export default actions;
